import type { TFunction } from "i18next";
import { WorkerEmploymentType } from "model/Salary";

interface EmploymentTypeLabelParams {
  readonly employmentType: string | null | undefined;
  readonly translate: TFunction | ((key: string) => string);
}

const EMPLOYMENT_TYPE_TRANSLATION_KEY_BY_VALUE: Record<string, string> = {
  [WorkerEmploymentType.EMPLOYEE]: "Staff.employmentTypeEmployee",
  [WorkerEmploymentType.TEMPORARY_WORKER]:
    "Staff.employmentTypeTemporaryWorker",
  [WorkerEmploymentType.EXCLUSIVE_TEMPORARY_WORKER]:
    "Staff.employmentTypeExclusiveTemporaryWorker",
  [WorkerEmploymentType.PROJECT_EMPLOYEE]:
    "Staff.employmentTypeProjectEmployee",
  [WorkerEmploymentType.SIMFLEXITY_EMPLOYEE]:
    "Staff.employmentTypeSimflexityEmployee",
  [WorkerEmploymentType.CONSULTANT]: "Staff.employmentTypeConsultant",
  [WorkerEmploymentType.TRAINEE]: "Staff.employmentTypeTrainee",
};

export function toEmploymentTypeLabel({
  employmentType,
  translate,
}: EmploymentTypeLabelParams): string {
  if (!employmentType || employmentType === WorkerEmploymentType.UNDEFINED) {
    return "-";
  }

  const translationKey =
    EMPLOYMENT_TYPE_TRANSLATION_KEY_BY_VALUE[employmentType];
  return translationKey ? translate(translationKey) : employmentType;
}
